export const LandSizeIcon = () => (
  <svg viewBox="0 0 460 460" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="24px">
    <g>
      <path d="M430.53 408.18H51.85V29.39M111.02 29.39h69.05"/>
      <path d="M225.42 29.39h113.39" strokeDasharray="90.71 45.36" strokeWidth="32px"/>
      <path d="M361.49 29.39h69.04v69.04"/>
      <path d="M430.53 145.11v116.7" strokeDasharray="93.36 46.68" strokeWidth="32px"/>
      <path d="M430.53 285.15v69.04M11.98 64.84l39.79-35.45 40.82 35.45M395.08 448.02l35.45-39.79-35.45-40.82M139.34 315v-92.87a42.91 42.91 0 0 1 42.92-42.92h0a42.91 42.91 0 0 1 42.92 42.92V315"/>
      <path d="M225.18 222.13a42.92 42.92 0 0 1 42.93-42.92h0A42.92 42.92 0 0 1 311 222.13V315M139.34 169.72v52.41M327.41 126.25a20.58 20.58 0 1 1 32.14 17l-32.14 26.45h41.15"/>
    </g>
  </svg>
);
